// extracted by mini-css-extract-plugin
export default {"container":"StarRating-module__container-OwCW","star":"StarRating-module__star-eSK7","starFilled":"StarRating-module__starFilled-ZwPG","partial":"StarRating-module__partial-t0CT"};